import { createClient } from '@/prismicio';
import { AuthorDocument } from '../../prismicio-types';
import { notFound } from 'next/navigation';

// Mirrors `getBlogPost` for the sibling `webinar_post` type. Same shape of
// linked-author fallback so `ArticleView` can render either without a branch.
export async function getWebinarPost(uid: string) {
  const client = createClient();
  const webinar = await client
    .getByUID('webinar_post', uid, {
      fetchLinks: ['author.name', 'author.avatar', 'blog_category.name'],
    })
    .catch(() => notFound());
  const authorReference = webinar.data.author as unknown as AuthorDocument;
  let author: Partial<AuthorDocument> = {
    data: {
      name: 'Devsu',
      avatar: {},
      company: null,
      job_title: null,
      bio: [],
      slices: [],
      meta_title: '',
      meta_description: '',
      meta_image: {},
      keywords: '',
      structured_data: [],
    },
  };

  try {
    if (authorReference?.uid) {
      author = await client.getByUID('author', authorReference.uid);
    }
  } catch {
    // Do nothing
  }

  return { webinar, author };
}
